import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=9cdbbda2&scoped=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=ts"
export * from "./PlatformIcon.vue?vue&type=script&lang=ts"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=9cdbbda2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbbda2",
  null
  
)

export default component.exports